import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";
import { Bounce, ToastContainer } from 'react-toastify';
import './App.css';
import CookieBanner from './components/CookieBanner';
import GoogleTag from './components/GoogleTag';
import { AuthProvider } from "./context/AuthProvider";
import CartPage from './pages/CartPage';
import CheckoutSuccess from './pages/CheckoutSuccess';
import HomePage from './pages/HomePage';
import TermsConfirmation from './pages/TermsConfirmation';
import WasteTypeDetail from './pages/WasteTypeDetail';


const queryClient = new QueryClient()
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route index element={<HomePage />} />
            <Route path="cart" element={<CartPage />} />
            <Route path="checkout/success" element={<CheckoutSuccess />} />
            <Route path="terms/:id" element={<TermsConfirmation />} />
            <Route path="wastetype/:id" element={<WasteTypeDetail />} />
          </Routes>
        </AuthProvider>
        <GoogleTag />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <CookieBanner />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
